var adFactory = require('src/interlock/product/ads/ad-unit-factory/ad-unit-factory.js');
var adContext = require('src/interlock/product/ads/ad-context/ad-context.js');
var adRefresh = require('src/interlock/product/ads/ad-manager/ad-retarget-refresh-manager.js');
var gptSlotIniter = require('src/interlock/product/ads/ad-manager/gpt-slot-initer.js');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

var _adUnits = [];
var _adUnitsSpecialCaseIds = [];

/**
 * Creates and preps a gpt slot object from an adUnit object
 * @param  {Object} adUnit
 * @return {Slot}
 */
function _setModuleLoaded(module) {
    if (window.googletag.pubads && module && module.indexOf('edm-entry') > -1) {
        window.googletag.pubads().setTargeting('module', module.replace(/#*edm-entry-/, ''));
    }
}
/**
 * Sets common (aka global) pub level targeting.  These values are common
 * to all ads.
 */
function _setCommonTargeting() {
    var moduleActive = $('.nav-link.active');  //get active module from navigation panel
    if (moduleActive) { _setModuleLoaded(moduleActive.data('target')); }
    var targeting = {};
    adContext.changeDartSiteName();
    var common = adContext.getCommonContext();
    $.extend(targeting, common.pageContext, common.visitorSpecific);
    for(var key in targeting) {
        window.googletag.pubads().setTargeting(key, targeting[key]);
    }
}
/**
 * Refreshes all ad units matching the given zone
 * @param  {String} zone refresh zone
 * @param  {Object} data event data
 * @return {void}
 */
function _refreshAdUnitsByZone(zone, data) {
    var adIdToSlot = gptSlotIniter.getAdIdToSlot();
    adRefresh.refreshAdUnitsByZone(adIdToSlot, _adUnits, zone, data);
}

/**
 * Refreshes all ad units
 * @param  {Object} data event data
 * @return {void}
 */
function _refreshAllAdUnits(data) {
    var adIdToSlot = gptSlotIniter.getAdIdToSlot();
    adRefresh.refreshAllAdUnits(_adUnits, adIdToSlot, data);
}

/**
 * Retarget ad units.  this is more expensive than refreshing so only call with
 * sitename or other top level targeting values change.  This will effect view ability and other
 * core metrics.
 *
 * @param  {String} zone refresh zone
 * @return {void}
 */

function _retargetAdUnitsByZone(zone) {
    var adIdToSlot = gptSlotIniter.getAdIdToSlot();
    _markAsNewPage();
    adRefresh.retargetAdUnitsByZone(adIdToSlot, _adUnits, zone,  _renderAds);
}

/**
 * Retarget all ad units.  this is more expensive than refreshing so only call with
 * sitename or other top level targeting values change.  This will effect view ability and other
 * core metrics.
 *
 * @return {void}
 */
function _retargetAllAdUnits(retargetExcludeSpecialCase) {
    var adIdToSlot = gptSlotIniter.getAdIdToSlot();
    _markAsNewPage();
    retargetExcludeSpecialCase ? adRefresh.retargetAllAdUnits(_adUnits, adIdToSlot, _renderAds, _adUnitsSpecialCaseIds)
        : adRefresh.retargetAllAdUnits(_adUnits, adIdToSlot, _renderAds);
}

/**
 * Returns true of the given adUnit needs rendering (aka calling display on it.)
 * @param  {Object} adUnit
 * @return {Boolean}
 */
function _shouldRender(adUnit) {
    return adUnit && !adUnit.isRendered();
}

/**
 * Renders any ad unit not already rendered.
 *
 * @return {[type]} [description]
 */
function _renderAds() {
    // create all slots and render
    // only one cmd.push as there is a delay in each one.
    window.googletag.cmd.push(function () {
        try {
            var unitsToRender = _adUnits.filter(_shouldRender);
            var groupByCorrelators = adRefresh.getAdUnitsGroupByCorrelator(unitsToRender);
            for (var correlator in groupByCorrelators) {
                var units = groupByCorrelators[correlator];
                window.googletag.pubads().updateCorrelator();
                _setCommonTargeting();
                units.forEach(gptSlotIniter.init);
                units.forEach(function (adUnit) {
                    window.googletag.display(adUnit.getContainerId());
                });
                // fire edw tracking pixel to denote we are rendering ads.
                // any ads in queue when _renderAds() is called should be included into one SRA call.
                eventToolbox.fireAction({
                    'event_type': 'action_completed',
                    'ads': {
                        'disable_refresh': 'true'
                    },
                    'event_data': {
                        'action_category': 'system',
                        'action_name': 'ad_load',
                        'action_cause':'page_load'
                    }
                });
            }
        } catch (ex) {
            //console.log('adManager:_add', ex.stack);
        }
    });
}

function _renderSingleAd(adUnit) {
    window.googletag.cmd.push(function () {
        try {
            _setCommonTargeting();
            gptSlotIniter.init(adUnit);
            window.googletag.display(adUnit.getContainerId());
        } catch (ex){
            //console.log(ex);
        }
    });
}

function _remove(adUnit) {
    var index = _adUnits.indexOf(adUnit);
    if (index >= 0) {
        _adUnits.splice(index, 1);
        $('#' + adUnit.getId()).remove();
    }
}

/**
 * Checks if adUnit exists in _adUnit.
 * @param adUnit
 * @returns {boolean}
 * @private
 */
function _exists(adUnit) {
    return _adUnits.indexOf(adUnit) !== -1;
}

/**
 * Adds new ad unit.  Will not render right away.  Ad will render/display  when renderAds gets called.
 * @param {Function} getCustomValues hook to get targeting values at the point of rendering.
 */
function _add(refreshZones, getCustomValues, deferOnAction, correlator, getModuleValue) {
    var adUnit = adFactory.createAdUnit(refreshZones, getCustomValues, correlator, getModuleValue);
    _adUnits.push(adUnit);
    if(deferOnAction) {
        _adUnitsSpecialCaseIds.push(adUnit.getId());
    }
    return adUnit;
}

/**
 * Flags as new page.  typically to force new correlator and other internal
 * values from gpt.
 * @return {[type]} [description]
 */
function _markAsNewPage() {
    if(window.googletag && window.googletag.pubads){
        window.googletag.pubads().updateCorrelator();
    }
}

module.exports = {
    add : _add,
    remove : _remove,
    exists: _exists,
    renderAds : _renderAds,
    renderSingleAd:_renderSingleAd,
    refreshAdUnitsByZone : _refreshAdUnitsByZone,
    refreshAllAdUnits:_refreshAllAdUnits,
    retargetAdUnitsByZone : _retargetAdUnitsByZone,
    retargetAllAdUnits:_retargetAllAdUnits,
    markAsNewPage : _markAsNewPage,
    setModuleLoaded: _setModuleLoaded
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-manager/ad-manager.js
// module id = 262
// module chunks = 36